import { css, keyframes } from "styled-components";

export enum Animations {
  FADE_OUT,
  FADE_IN,
  MOVE_UP_AND_FADE_IN,
}

export const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

export const fadeOut = keyframes`
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;

export const moveDownAndFadeIn = (props: any) => keyframes`
    0% {
        opacity: 0;
        transform: translateY(-${props.size || `30px`});
    }
    100% {
        opacity: 1;
        transform: translateY(0px);
    }
`;

export const moveUpAndFadeIn = (props: any) => keyframes`
    0% {
        opacity: 0;
        transform: translateY(${props.size || `30px`});
    }
    100% {
        opacity: 1;
        transform: translateY(0px);
    }
`;

export const moveUpAndFadeOut = (props: any) => keyframes`
    0% {
        opacity: 1;
        transform: translateY(0px);
    }
    100% {
        opacity: 0;
        transform: translateY(-${props.size || `30px`});
    }
`;

export const zoomOut = keyframes`
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
`;

export const backgroundFade = (props: any) => keyframes`
    0% {
        background-color: transparent;
    }
    100% {
        background-color: ${props.background};
    }
`;

export const rippleScale = (scale: number) => keyframes`
    0% {
        transform: scale(0);
    }
    100% {
        opacity: 0;
        transform: scale(${scale});
        zoom: 150%;
    }
`;

export const rippleEffect = (props: any) => css`
  position: relative;
  transform: translate3d(0, 0, 0);

  &:before {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: ${props.opacity || 0.5};
    visibility: ${props.overlay ? "visible" : "hidden"};
    background-color: ${props.background || "transparent"};
    z-index: 1;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background-image: radial-gradient(
      circle,
      ${props.background} 10%,
      transparent 10.01%
    );
    background-repeat: no-repeat;
    background-position: 50%;
    transform: scale(10, 10);
    zoom: 150%;
    opacity: 0;
    transition: transform ${(props.timing || 1000) / 2}ms,
      opacity ${props.timing || 1000}ms;
  }

  &:active:after {
    transform: scale(0, 0);
    opacity: ${props.opacity || 0.4};
    transition: 0s;
    visibility: ${props.overlay ? "hidden" : "visible"};
  }
`;

export const rippleEffectRuntime = (props: any) => css`
  position: relative;
  transform: translate3d(0, 0, 0);
  background-color: transparent;
  animation: ${backgroundFade(props)} ${props.timing || 1000}ms forwards;
  animation-delay: ${(props.timing || 1000) / 10}ms;

  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: ${props.background};
    border-radius: 100%;
    opacity: ${props.opacity};
    transform: scale(0);
    animation: ${rippleScale(2)} ${props.timing || 1000}ms ease-out;
    animation-delay: ${(props.timing || 1000) / 10}ms;
  }
`;

export const backgroundFadeWithOverlay = (props: any) => css`
  position: relative;
  transform: translate3d(0, 0, 0);
  background-color: transparent;
  animation: ${backgroundFade(props)} ${props.timing || 1000}ms
    ${props.animationDelay || 0}ms ease-out forwards;

  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    opacity: ${props.opacity};
    animation: ${backgroundFade(props)} ${props.timing || 1000}ms
      ${props.animationDelay || 0}ms ease-out forwards;
  }
`;
